import "nprogress/nprogress.css";
import "select2/dist/css/select2.min.css";
import "bootstrap4c-dropzone/dist/css/component-dropzone.min.css";
import "animate.css/animate.min.css";
import "cropperjs/dist/cropper.css";
import "easy-autocomplete/dist/easy-autocomplete.min.css";
import "bootstrap-datepicker/dist/css/bootstrap-datepicker.min.css";
import "bootstrap-colorpicker/dist/css/bootstrap-colorpicker.min.css";
import "pretty-checkbox/dist/pretty-checkbox.min.css";
import "@Shared/@Styles/loading";
import "summernote/dist/summernote-bs4.css";
import "@Broker/@Styles/custom.scss";
import "@Shared/@Styles/style";
import "@Shared/@Styles/navbars";
import "@Shared/@Styles/dashboard";
import "@Shared/@Styles/documents";
import "@Shared/@Styles/login";
import "@Shared/@Styles/application";
import "@Shared/@Styles/responsive";
import "select2-bootstrap4-theme/dist/select2-bootstrap4.css";
import "@Broker/@Styles/text.scss";
import "@Shared/@Styles/override";
import "@Shared/@Styles/grid";
import "vue2-timepicker/dist/VueTimepicker.css";
import "firebase/messaging";
import "jquery";
window.$ = $;
import "jquery-serializejson/jquery.serializejson.min.js";
import "bootstrap-datepicker/dist/js/bootstrap-datepicker.min.js";
import "bootstrap-datepicker/dist/locales/bootstrap-datepicker.fr.min.js";
import "popper.js/dist/umd/popper.min.js";
import "bootstrap";
import "easy-autocomplete/dist/jquery.easy-autocomplete.min.js";
import "moment-timezone/builds/moment-timezone-with-data-2012-2022.min.js";
import "select2/dist/js/select2.full.min.js";
import "select2/dist/js/i18n/fr.js";
import "better-timezone-latest/src/better-timezone.js";
import "is-in-viewport/lib/isInViewport.min.js";
import "jquery.scrollto/jquery.scrollTo.min.js";
import "@doorr/parsleyjs";
import "@doorr/parsleyjs/dist/i18n/fr";
import "@doorr/parsleyjs/dist/i18n/en";
import "bootstrap-colorpicker/dist/js/bootstrap-colorpicker.min.js";
import "rrule/dist/es5/rrule-tz.min.js";
import "inputmask";
import "jquery.animate-number/jquery.animateNumber.min.js";
import "summernote/dist/summernote-bs4.min.js";
import "summernote/dist/lang/summernote-fr-FR";
import "parse-address/parse-address.min.js";
import "proxy-polyfill/proxy.min.js";
import "select2";
import "numeral/locales/fr-ca";
import "@Shared/@Utils/configure-plugins";
import "./js/index";